export const validateLicensePlate = (plate: string): boolean => {
  return plate.length >= 1 && plate.length <= 8;
};

export const validateState = (state: string): boolean => {
  return state.length === 2;
};

export const validateDescription = (description: string): boolean => {
  return description.length >= 10 && description.length <= 500;
};

export const validateReason = (reason: string): boolean => {
  return reason.length > 0;
};

export const validateGeoLocation = (location: string): boolean => {
  return location.length > 0;
};

export const getCurrentTimestampEST = (): string => {
  const now = new Date();
  const estOptions: Intl.DateTimeFormatOptions = {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };
  
  return now.toLocaleString('en-US', estOptions);
};

export const getCurrentTimestampForInput = (): string => {
  const now = new Date();
  // Convert to EST
  const estDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  
  // Format for datetime-local input (YYYY-MM-DDTHH:MM)
  const year = estDate.getFullYear();
  const month = String(estDate.getMonth() + 1).padStart(2, '0');
  const day = String(estDate.getDate()).padStart(2, '0');
  const hours = String(estDate.getHours()).padStart(2, '0');
  const minutes = String(estDate.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatTimestamp = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);
    const estOptions: Intl.DateTimeFormatOptions = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    
    return date.toLocaleString('en-US', estOptions);
  } catch (error) {
    return timestamp; // Return original if parsing fails
  }
};

export const formatTimestampForDisplay = (timestamp: string): string => {
  try {
    const date = new Date(timestamp);
    const estOptions: Intl.DateTimeFormatOptions = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    
    return date.toLocaleString('en-US', estOptions);
  } catch (error) {
    return timestamp; // Return original if parsing fails
  }
}; 